<template>
  <div>
    {{ error.statusCode }}
    {{ error.message }}
  </div>
</template>

<script setup>
const props = defineProps({
  error: {
    default: {
      statusCode: 500,
      statusMessage: '服务器开小差啦，请稍后重试',
    }
  }
})
const code = props.error.statusCode
console.log('ERROR Page: ', props);

const { locale } = useI18n();
if (useRuntimeConfig().public.env !== "dev") {
  if (code === 404) {
  let newlocale = locale.value + '/'
  if (locale.value == 'en') {
    newlocale = ''
  }
  const toPath = `/${newlocale}${code}`
  navigateTo(toPath, {
    external: true
  })
}
if (code === 500) {
  let newlocale = locale.value + '/'
  if(locale.value == 'en'){
    newlocale = ''
  }
  const toPath = `/${newlocale}${code}`
  navigateTo(toPath, {
    external: true
  })
}
}

</script>

<style></style>
